'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.FaresOptimizer.RecalculatePersistModal', dependencies).controller('RecalculatePersistModalController', require('./controllers/RecalculatePersistModalController')).directive('rmRecalculatePersistModal', require('./directives/RecalculatePersistModalDirective')).constant('FaresOptimizerConstants', require('../../constants/FaresOptimizerConstants'));